export enum RoomvoProductType {
    COUNTERTOP = 'countertop',
}

interface RoomvoButtonContainerProps {
    children: React.ReactNode;
    productType?: RoomvoProductType;
    sku: string;
}

/**
 * Applies specifications required for the button that calls Roomvo's visualizer
 * @param props.productType The surface where the visualizer will apply the product
 * @param props.sku Unique identifier of the product in Roomvo's database
 * @see https://inscyth-inc.atlassian.net/wiki/spaces/EZE/pages/2452160513/Roomvo+Visualizer
 */
const RoomvoButtonContainer = ({
    children,
    productType = RoomvoProductType.COUNTERTOP,
    sku,
}: RoomvoButtonContainerProps): JSX.Element => {
    return (
        <div className="roomvo-container" data-product-type-str={productType}>
            <div className="roomvo-stimr" data-sku={sku} style={{ visibility: 'hidden' }}>
                {children}
            </div>
        </div>
    );
};

export default RoomvoButtonContainer;
